import { render, staticRenderFns } from "./ChooseCreateChannel.html?vue&type=template&id=2464df15&scoped=true&"
import script from "./ChooseCreateChannel.js?vue&type=script&lang=js&"
export * from "./ChooseCreateChannel.js?vue&type=script&lang=js&"
import style0 from "./ChooseCreateChannel.scss?vue&type=style&index=0&id=2464df15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2464df15",
  null
  
)

export default component.exports